import React from 'react';
import {useSelector} from "react-redux";
import {custHistoryLoading, customerHistory} from "./customerHistorySlice";
import {Card, Col, Row, Spinner} from "@deere/ux.uxframe-react";
import {Link} from "react-router-dom";
import {languageResponseData} from "../Translation/translationSerachSlice";

const CustomerHistory = ({restrictedDetails}) => {
    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
    return translationsResponse[key] || defaultText;
    };;

    const restrictedCustomerInfo = restrictedDetails;
    const custHistoryList = useSelector(customerHistory);
    const totalCust = custHistoryList?.length;
    const loading = useSelector(custHistoryLoading);
    return (
        <>
            {
                !loading ? (
                    custHistoryList && custHistoryList.length > 0 ? (
                        custHistoryList.map((customer, i) => {
                            return (
                                <Card key={i}>
                                    <Card.Header>
                                        <p><strong>Customer {totalCust - i} of {totalCust}</strong></p>
                                    </Card.Header>
                                    <Card.Body>
                                        <CustomerHistoryData customer={customer}
                                                             restrictCustomerDetails={restrictedCustomerInfo}></CustomerHistoryData>
                                    </Card.Body>
                                </Card>
                            )
                        })
                    ) : (
                        <span>{translate('message11','No customer found for the machine.')}</span>
                    )
                ) : (
                    <div className="uxf-spinner-border-inline mt-4">
                        <Spinner className="uxf-spinner-border-sm" animation="border"
                                 accessibilityLabel="Loading Customers"/>
                        <p aria-hidden="true" className="uxf-spinner-border-inline-text">
                            Loading customers...
                        </p>
                    </div>
                )
            }
        </>
    );
};

export const CustomerHistoryData = ({customer, restrictCustomerDetails}) => {

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse[key] || defaultText;
    };
    const restrictCustDetails = restrictCustomerDetails;
    let custName = "", homePhone = "", workPhone = "", mobilePhone = "";
    const custData = customer?.customer;
    let customerAddress = custData?.addresses[0];

    if (custData) {
        if (custData.homePhone) {
            homePhone = custData.homePhone?.countryCode + custData.homePhone?.areaCode + custData.homePhone?.phoneNumber;
        }
        if (custData.workPhone) {
            workPhone = custData.workPhone?.countryCode + custData.workPhone?.areaCode + custData.workPhone?.phoneNumber;
        }
        if (custData.mobilePhone) {
            mobilePhone = custData.mobilePhone?.countryCode + custData.mobilePhone?.areaCode + custData.mobilePhone?.phoneNumber;
        }
        if (custData.customerType === "BUSINESS") {
            /*custName = custData.businessName1 ?? custData.businessName2;*/
            const businessName1 = custData?.businessName1 && custData.businessName1.trim() !== "" ? custData.businessName1 + " " : "";
            const businessName2 = custData?.businessName2 && custData.businessName2.trim() !== "" ? custData.businessName2 : "";
            custName = businessName1 + businessName2;
        } else {
            const firstName = custData?.firstName && custData.firstName.trim() !== "" ? custData.firstName + " " : "";
            const middleName = custData?.middleName && custData.middleName.trim() !== "" ? custData.middleName + " " : "";
            const lastName = custData?.lastName && custData.lastName.trim() !== "" ? custData.lastName : "";
            custName = firstName + middleName + lastName;
        }
    }

    const formatDate = (dateString) => {
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        };

        if (dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', options);
        } else return "";
    };

    return (
        <div className="mt-3">
            <Col>
                {
                    custData && (
                        <Row>
                            {
                                restrictCustDetails === "true" ? (
                                    <>
                                        <Col>
                                            <dl>
                                                <dd>{custName}</dd>
                                                <dd></dd>
                                                <dd></dd>
                                                <dd>{" "}</dd>
                                            </dl>
                                            <dl className="uxf-dl uxf-dl-horizontal mb-md-0">
                                                <dt>{translate('home','Home:')}</dt>
                                                <dd></dd>
                                                <dt>{translate('cell','Cell:')}</dt>
                                                <dd></dd>
                                                <dt>{translate('work','Work:')}</dt>
                                                <dd></dd>
                                                <dt>{" "}</dt>
                                                <dd>{" "}</dd>
                                            </dl>
                                            <dl className="uxf-dl uxf-dl-horizontal mb-md-0">
                                                <dt>{translate('selling_dealer','Selling Dealer:')}</dt>
                                                <dd></dd>
                                                <dt>{translate('responsible_dealer','Responsible Dealer:')}</dt>
                                                <dd></dd>
                                            </dl>
                                        </Col>
                                        <Col>
                                            <dl className="uxf-dl uxf-dl-horizontal mb-md-0">
                                                <dt>{translate('customer_number','Customer Number:')}</dt>
                                                <dd></dd>
                                                <dt>{translate('purchase_type','Purchase Type:')}</dt>
                                                <dd></dd>
                                                <dt>{translate('end_use_code','End Use Code:')}</dt>
                                                <dd></dd>
                                                <dt>{" "}</dt>
                                                <dd>{" "}</dd>
                                            </dl>
                                        </Col>
                                    </>
                                ) : (
                                    <>
                                        <Col>
                                            <dl>
                                                <dd><Link
                                                    to={{
                                                        pathname:`/machine-search/customer/${custData?.entityId}/machines`,
                                                        state:{customer: customer.customer}
                                                    }}
                                                >
                                                    {custName}
                                                </Link></dd>
                                                <dd>{customerAddress.street}</dd>
                                                <dd>{customerAddress.city}, {customerAddress.state}, {customerAddress.country}</dd>
                                                <dd>{" "}</dd>
                                            </dl>
                                            <dl className="uxf-dl uxf-dl-horizontal mb-md-0">
                                                <dt>{translate('home','Home:')}</dt>
                                                <dd>{homePhone}</dd>
                                                <dt>{translate('cell','Cell:')}</dt>
                                                <dd>{mobilePhone}</dd>
                                                <dt>{translate('work','Work:')}</dt>
                                                <dd>{workPhone}</dd>
                                                <dt>{" "}</dt>
                                                <dd>{" "}</dd>
                                            </dl>
                                            <dl className="uxf-dl uxf-dl-horizontal mb-md-0">
                                                <dt>{translate('selling_dealer','Selling Dealer:')}</dt>
                                                <dd>{customer.sellingDealer}</dd>
                                                <dt>{translate('responsible_dealer','Responsible Dealer:')}</dt>
                                                <dd>{customer.responsibleDealer}</dd>
                                            </dl>
                                        </Col>
                                        <Col>
                                            <dl className="uxf-dl uxf-dl-horizontal mb-md-0">
                                                <dt>{translate('customer_number','Customer Number:')}</dt>
                                                <dd>{custData.entityId}</dd>
                                                <dt>{translate('purchase_type','Purchase Type:')}</dt>
                                                <dd>{customer.purchaseType}</dd>
                                                <dt>{translate('end_use_code','End Use Code:')}</dt>
                                                <dd>{customer.endUseCodeDesc}</dd>
                                                <dt>{" "}</dt>
                                                <dd>{" "}</dd>
                                                <dt>{translate('delivery_date','Delivery Date')}</dt>
                                                <dd>{formatDate(customer.deliveryReceiptDate)}</dd>
                                            </dl>
                                        </Col>
                                    </>
                                )
                            }
                        </Row>
                    )
                }
            </Col>
        </div>
    )
}

export default CustomerHistory;